export default __webpack_public_path__ + "static/media/july.b4dd3955.jpg";